export default __webpack_public_path__ + "media/assets/fonts/roboto-slab-v13-latin-regular-839e5a2027e92f878f784912be360816.woff2";